import { useCallback } from 'react'

import { useQueryClient } from '@tanstack/react-query'

import { useNavigate } from 'Pods/Shared/ContextBasedRouter'
import useApiDelete from 'Pods/Shared/Hooks/useApiDelete'
import {
  removeImageRunFromLibraryCache,
} from 'Pods/ThreeDStudio/Components/Sidebar/Components/LibraryContent/Services/removeSessionFromLibraryCache'
import { STUDIO_PATH } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

const showNotification = (message, type) => {
  if (typeof window !== 'undefined' && window.showNotification) {
    window.showNotification(message, { type, autohide: true })
  }
}

// Deleting an image removes one run, not a session: the Images tab lists individual image
// runs, and the session it belongs to usually holds several more.
function useDeleteImageRun({ onSuccess, onError } = {}) {
  const t = useTranslation()
  const queryClient = useQueryClient()
  const navigate = useNavigate()
  const { deleteData, isLoading } = useApiDelete()

  const deleteImage = useCallback((runId) => {
    if (runId == null) return

    deleteData({
      path: `/api/internal/generator/runs/${runId}`,
      onSuccess: () => {
        removeImageRunFromLibraryCache(queryClient, { runId })
        navigate(STUDIO_PATH.IMAGE_GENERATOR)

        showNotification(t('sidebar.imageCard.notifications.deleteSuccess'), 'success')
        if (onSuccess) onSuccess()
      },
      onError: (error) => {
        showNotification(t('sidebar.imageCard.notifications.deleteError'), 'error')
        if (onError) onError(error)
      },
    })
  }, [deleteData, navigate, onError, onSuccess, queryClient, t])

  return { deleteImage, isLoading }
}

export default useDeleteImageRun
